module.exports = __webpack_public_path__ + "img/Freeze card.b7b8643a.svg";